import script from "./Sta.vue?vue&type=script&setup=true&lang=js"
export * from "./Sta.vue?vue&type=script&setup=true&lang=js"

import "./Sta.vue?vue&type=style&index=0&id=0bd7a8c0&lang=css"

const __exports__ = script;

export default __exports__